@if ((showTotals$ | async) !== true) {
  <app-bex-overview></app-bex-overview>
}
@if ((showTotals$ | async) === true) {
  <app-bex-totals></app-bex-totals>
}

<p class="text--small wrapper--spacing-horizontal flex--column">
  <span>{{ 'bex.disclaimer1' | translate }}</span>
  <span>{{ 'bex.disclaimer2' | translate }}</span>
</p>
